import cx from "classnames";
import { LocationDescriptor } from "history";
import React, { useCallback } from "react";
import { ListRowProps } from "react-virtualized";

import CategoryListItem, { Category } from "@/mk2/apps/bazaar/components/CategoryListItem";
import { InfiniteListLoadable } from "@/mk2/components/InfiniteListLoadable";

import styles from "./CategoriesList.mscss";

const ROW_HEIGHT = 44;
const isRowLoaded = () => true;
const loadMoreRows = () => null; // Noop

export interface OwnProps {
    className?: string;
    categories: Category[];
    showIcons?: boolean;
    selected?: string;
    counts?: {
        [category: string]: number;
    };

    generateCategoryTo?(category: string): LocationDescriptor;
    onClick?(category: Category);
}

type Props = OwnProps;

const CategoriesList: React.FunctionComponent<Props> = ({
    className,
    categories,
    showIcons = true,
    generateCategoryTo,
    onClick,
    selected,
    counts,
}) => {
    const rowRenderer = useCallback(
        ({ index, key, style }: ListRowProps) => {
            const cat = categories[index];
            return (
                <CategoryListItem
                    key={key}
                    style={style}
                    category={cat}
                    disabled={cat.disabled}
                    needsPlusPro={cat.needsPlusPro}
                    needsPro={cat.needsPro}
                    onClick={cat.disabled ? null : onClick}
                    isLast={index + 1 === categories.length}
                    showIcon={showIcons}
                    selected={selected === cat.name}
                    generateCategoryTo={generateCategoryTo}
                    count={counts && counts[cat.name]}
                />
            );
        },
        [categories, generateCategoryTo, showIcons, selected, onClick, counts],
    );

    return (
        <div className={cx(styles.CategoriesList, className)}>
            <InfiniteListLoadable
                isRowLoaded={isRowLoaded}
                loadMoreRows={loadMoreRows}
                rowCount={categories.length}
                rowHeight={ROW_HEIGHT}
                rowRenderer={rowRenderer}
                numberOfItemsOnFirstPage={15}
            />
        </div>
    );
};

CategoriesList.displayName = "CategoriesList";

export default React.memo<Props>(CategoriesList);
